<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" />
        <!-- Card body -->
        <form role="form" @submit.prevent="create">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error') }} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <div class="row">
              <select-ticket-root-type-action-types v-model="type" :options="{ id: 'type', label: 'type', params: { ticketId: id, typeId: type_id }, error: fieldErrors.type }"/>
            </div>
            <div class="row">
              <input-checkbox v-model="is_auto" :options="{ id: 'is_auto', label: 'is_auto', error: fieldErrors.isAuto }"/>
              <input-checkbox v-model="enabled" :options="{ id: 'enabled', label: 'enabled', error: fieldErrors.enabled }"/>
            </div>
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <router-link :to="{ name: `${routePrefix}.index`}"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
                <button type="submit" class="btn btn-primary btn-sm" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                  <i class="fa fa-save"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import { TICKETS_ROOTS_TYPES_ACTIONS_CREATE as CRUD_ACTION_CREATE } from 'actions/tickets';

  const TICKETS_CODE="tickets";
  const TICKETS_ROOTS_CODE=`${TICKETS_CODE}.roots`;
  const TICKETS_ROOTS_TYPES_CODE=`${TICKETS_ROOTS_CODE}.types`;
  const CRUD_CODE=`${TICKETS_ROOTS_TYPES_CODE}.actions`;
  export default {
    name: "TicketRootTypeActionCreate",
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        ticketsRoutePrefix: TICKETS_CODE,
        ticketsTransPrefix: TICKETS_CODE,
        ticketRootsRoutePrefix: TICKETS_ROOTS_CODE,
        ticketRootsTransPrefix: TICKETS_ROOTS_CODE,
        ticketRootTypesRoutePrefix: TICKETS_ROOTS_TYPES_CODE,
        ticketRootTypesTransPrefix: TICKETS_ROOTS_TYPES_CODE,
        id:this.$router.currentRoute.params.id,
        type_id:this.$router.currentRoute.params.type_id,
        type: '',
        is_auto: false,
        enabled: false,
        serverError: '',
        fieldErrors: {},
        loading: false,
      }
    },
    methods: {
      prepareRequestData(){
        return {
          type: this.sanitizeField('type'),
          isAuto: this.sanitizeField('is_auto'),
          enabled: this.sanitizeField('enabled'),
          ticketId: this.sanitizeField('id'),
          typeId: this.sanitizeField('type_id'),
        }
      },
      create() {
        this.loading = true;
        this.$store.dispatch(CRUD_ACTION_CREATE, {
          ...this.prepareRequestData(),
        })
        .then(() => {
          swal({
            icon: 'success',
            text: this.$i18n.t("messages.create_successfully"),
            buttons:false,
            timer: 5000
          });
          this.$router.push({ name: `${this.routePrefix}.index` })
        })
        .catch(error => {
          this.loading = false;
          this.fieldErrors={};
          this.serverError='';

          if(error.response){
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        })
      }
    }
  };
</script>
